export default "__VITE_ASSET__COnU8qja__"